import { GuardedDeletionService } from 'orchestrator';
import { Component, inject } from '@angular/core';
import { CertificationLevelService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  CertificationLevelCreateDto,
  CertificationLevelDto,
  CertificationLevelExcelDownloadDto,
  CertificationLevelUpdateDto,
} from '../proxy/planning/dtos/certification-level';
import { CERTIFICATIONLEVEL_CONFIG, CERTIFICATIONLEVEL_FIELDS } from './certification-level.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-certification-level',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, CertificationLevelService, ConfirmationService],
  templateUrl: './certification-level.html',
  styleUrl: './certification-level.scss',
})
export class CertificationLevel extends BaseCrudComponent<
  CertificationLevelDto,
  CertificationLevelCreateDto,
  CertificationLevelUpdateDto,
  CertificationLevelExcelDownloadDto
> {
  private readonly guardedDeletion = inject(GuardedDeletionService);
  service = {
    ...inject(CertificationLevelService),
    deleteByIds: (ids: number[]) => this.guardedDeletion.deleteByIds('CertificationLevel', ids),
  };
  config = CERTIFICATIONLEVEL_CONFIG;
  fields = CERTIFICATIONLEVEL_FIELDS;

  protected prepareUpdateDto(data: any, selected: CertificationLevelDto): CertificationLevelUpdateDto {
    return {
      name: data.name,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'CertificationLevel';
  }
}
